import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import BrightDataSync from "./BrightDataSync";
import BrightDataBrowser from "./BrightDataBrowser";
import UploadTab from "./UploadTab";

export default function BrightPage() {
  const [tab, setTab] = useState("sync");

  return (
    <div className="p-4 md:p-6" data-testid="bright-page">
      <div className="mb-4">
        <h1 className="text-xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          Web-indexing Service
        </h1>
        <p className="text-xs text-slate-500 mt-0.5">Manage data sync, browse imported data, or upload manually</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4 bg-slate-100 p-1 rounded-lg" data-testid="bright-tabs">
          <TabsTrigger value="sync" className="text-sm px-5 data-[state=active]:bg-white data-[state=active]:shadow-sm rounded-md" data-testid="bright-tab-sync">
            Data Sync
          </TabsTrigger>
          <TabsTrigger value="browser" className="text-sm px-5 data-[state=active]:bg-white data-[state=active]:shadow-sm rounded-md" data-testid="bright-tab-browser">
            Data Browser
          </TabsTrigger>
          <TabsTrigger value="upload" className="text-sm px-5 data-[state=active]:bg-white data-[state=active]:shadow-sm rounded-md" data-testid="bright-tab-upload">
            Upload
          </TabsTrigger>
        </TabsList>

        <TabsContent value="sync" className="mt-0">
          <BrightDataSync />
        </TabsContent>
        <TabsContent value="browser" className="mt-0">
          <BrightDataBrowser />
        </TabsContent>
        <TabsContent value="upload" className="mt-0">
          <UploadTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
